import React, { Fragment } from 'react';
import Helmet from 'react-helmet';
import { Text } from 'localmed-core';
import { injectIntl } from 'react-intl';

import { Status } from '../../../_universal';
import DiLayout from './DiLayout';

import DiFailure from './DiFailure';

function DiNotFoundPage({
  title = 'Oops.',
  children = <Text color="black">Site not found. Please try again.</Text>,
  intl,
  size = 'sm',
}) {
  return (
    <DiLayout size={size}>
      <Status statusCode={404} />
      <Helmet>
        <title>
          {intl.formatMessage({
            id: 'DiLayout.DiNotFoundPage.title',
            defaultMessage: 'Page not Found',
          })}
        </title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <DiFailure title={title}>
        <Fragment>{children}</Fragment>
      </DiFailure>
    </DiLayout>
  );
}

export default injectIntl(DiNotFoundPage);
